<template>
  <div >
    <div class="content-title">
      ・Deadline Group {{ listNumber + 1 }}
    </div>
    <b-container fluid="lg" class="content">
      <b-row>
        <b-col cols="6" class="left-box">
          <div>
            <ValidationProvider
              :name="`Datetime_${listNumber}`" rules="required" v-slot="{ errors }"
            >
              <div class="item-text">Datetime</div>
              <DatetimeInput v-model="afterDeadlineInput" />
              <div class="error-text">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
          <div>
            <ValidationProvider
              :name="`Comment_${listNumber}`" rules="required" v-slot="{ errors }"
            >
              <div class="item-text">Comment</div>
              <Textarea class="textarea" v-model="comment" />
              <div class="error-text">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
        </b-col>
        <b-col cols="6" class="right-box">
          <b-row>
            <b-col cols="5">
              <div class="mb-2">
                <span class="before-title">before</span>
              </div>
              <div class="date-text">{{ (deadlines ? deadlines[0].expired : null) | ymdhm }}</div>
            </b-col>
            <b-col cols="2" class="d-flex align-items-center justify-content-center">→</b-col>
            <b-col cols="5">
              <div class="mb-2">
                <span class="after-title">after</span>
              </div>
              <div class="date-text">{{ afterDeadlineInput | ymdhm }}</div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <div class="booth-list">
      <b-table
        striped
        hover
        fixed
        Outlined
        show-empty
        :empty-text="'No data available'"
        :items="deadlines"
        :fields="fields"
        :table-class="'list-table text-center'"
        :thead-class="'list-table__head'"
        :tbody-class="'list-table__body'"
      >
      </b-table>
    </div>

    <div class="pager-box">
      <PagerComponent v-model="pager" @changePage="fetch" class="mb-2"/>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Textarea from '@/components/parts/inputItem/Textarea.vue'
import DatetimeInput from '@/components/parts/inputItem/DatetimeInput.vue';
import { Moment } from 'moment'
import { Level } from '@/store/master/types'
import { extend, ValidationProvider } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { DeadlineExpiredUpdateParams, DeadlineConditions } from '@/store/deadlines/types'
import { mapState } from 'vuex';
import PagerComponent from '@/components/parts/Pager.vue';

// バリデーションルール
extend('required', rules.required);
extend('required', { message: 'required.' });

export default Vue.extend({
  data(): {
    afterDeadlineInput: Moment|null,
    fields: Array<object>,
    comment: string|null,
    } {
    return {
      afterDeadlineInput: null,
      fields: [
        {
          key: 'type',
          label: 'Task Type',
        },
        {
          key: 'expired',
          label: 'Deadline',
          formatter: (date: Moment): string => date.format('YYYY-MM-DD HH:mm'),
        },
        {
          key: 'lesson.datetime',
          label: 'Lesson Date',
          formatter: (datetime: Moment): string => datetime.format('YYYY-MM-DD'),
        },
        {
          key: 'tutor.tutorId',
          label: 'Tutor ID',
        },
        {
          key: 'tutor.name',
          label: 'Tutor',
        },
        {
          key: 'lesson.period',
          label: 'Period',
        },
        {
          key: 'lesson.level',
          label: 'Level',
          formatter: (level: Level) => level?.code,
        },
        {
          key: 'comment',
          label: 'Comment',
        },
      ],
      comment: '',
    };
  },

  components: {
    Textarea,
    DatetimeInput,
    ValidationProvider,
    PagerComponent,
  },

  computed: {
    ...mapState({
      /* eslint-disable */
      //@ts-ignore
      deadlines(state: any) {
        //@ts-ignore
        return state.deadlines.each[this.listNumber]?.deadlines
      },
      //@ts-ignore
      pager(state: any) {
        //@ts-ignore
        return state.deadlines.each[this.listNumber]?.pager
        /* eslint-disable */
      },
    }),
  },

  filters: {
    ymdhm: (datetime: Moment|null): string => {
      return datetime ? datetime.format('YYYY-MM-DD HH:mm') : '----------------'
    },
  },

  async created() {
    await this.fetch()
  },

  methods: {
    async fetch(page = 1) {
      const conditions: DeadlineConditions = {
        ids: (this.deadlineIds as string[]),
      };
      await this.$store.dispatch('fetchDeadlines', { conditions, page, index: this.listNumber });
    },
    async register() {
      await this.$store.dispatch('updateDeadlinesExpired', {
        ids: this.deadlineIds,
        expired: this.afterDeadlineInput,
        comment: this.comment,
      } as DeadlineExpiredUpdateParams)
    },
  },

  props: {
    deadlineIds: Array,
    listNumber: Number,
  },
});
</script>

<style>
.DeadlineModification__datepickerInput {
  border:none;
  font-size:15px;
  display:block;
  padding:5px 20px;
  background:none;
  cursor:pointer;
  width: 100%;
}

.booth-list .list-table .list-table__head {
  font-size: .6rem;
}

.booth-list .list-table .list-table__body td {
  font-size: .6rem;
}

.booth-list .btn {
  min-width: 60px;
  padding: 10px 0;
  font-size: 1rem;
  line-height: .5;
}

</style>

<style scoped>
.content-title {
  background: #B3C6E7;
  padding:5px 10px;
  color: #fff;
}

.content {
  background: #fff;
  padding: 15px;
}

.item-text {
  margin-bottom: 10px;
}

.center-border {
  margin: auto;
  width:10px;
  height: 40%;
  background: #000;
}

.lesson-date {
  background: #DDEAF6;
  border-radius:30px;
  border: #AAAFB6 1px solid;
}

.left-box {
  border-right: 5px solid #B3C6E7;
}

.right-box {
  border-left: 5px solid #B3C6E7;
}

.textarea {
  background: #DDEAF6;
  border: #AAAFB6 1px solid;
}

.before-title {
  color: #fff;
  background: #2E75B5;
  padding: 5px 20px;
  border-radius: 30px;
}

.after-title {
  color: #fff;
  background: #D84C60;
  padding: 5px 20px;
  border-radius: 30px;
}

.date-text {
  margin-left: 10px;
  font-size: 16px;
}

.error-text {
  text-align: left;
  margin-left:5px;
}
</style>
